import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams } from "react-router-dom"

import GuestLayout from "../components/GuestLayout"

import * as cartSlice from "../store/cart"
import * as productApis from "../utilities/apis/product"
import { url } from "../utilities/enumerations/constants"

const Product = () => {
  const dispatch = useDispatch()
  const cartState = useSelector((state) => state.cart)
  const { slug } = useParams()
  const [product, setProduct] = useState(null)

  const handleCart = async () => {
    dispatch(cartSlice.addToCart({ type: "product", ...product }))
  }

  const handleDecrement = async () => {
    dispatch(cartSlice.handleCartDecrement(product.slug))
  }

  const handleIncrement = async () => {
    if (cartState.cartById[product.slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleCartIncrement(product.slug))
  }

  const getProduct = async () => {
    try {
      const response = await productApis.getHomeProduct(slug)
      if (!response.status) throw new Error(response.message)

      setProduct(response.product)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (slug) getProduct()
  }, [slug])

  if (!product) return

  let src = "/upload-white.png"
  if (product.thumbnail) src = product.thumbnail
  if (product.thumbnail_url) src = product.thumbnail_url.replace("public", url)

  return (
    <GuestLayout
      header={true}
      footer={true}
    >
      <div className="container py-4">
        <div className="row gy-3 gy-md-0 mb-4">
          <div className="col-md-4">
            <div className="mb-3">
              {product.video_url && <iframe src={product.video_url} className="thumbnail rounded-2"></iframe>}
              {!product.video_url && <img src={src} alt={product.title} className="thumbnail border rounded-2" />}
            </div>
          </div>
          <div className="col-md-8">
            <div className="d-flex flex-column gap-4">
              <h1 className="text-body-emphasis fw-bold m-0">{product.title}</h1>

              <div>
                <p className="text-body-tertiary fw-semibold m-0">Description</p>
                <p className="text-body-emphasis m-0">{product.description}</p>
              </div>

              <div className="d-flex gap-3 align-items-center">
                <p className="lead bg-theme-light text-theme fw-bold rounded-2 px-2">Rs. {product.price.toFixed(2)}</p>
              </div>

              {
                !cartState.cartById[product.slug]
                  ? <button className="btn btn-theme rounded-2 w-25" onClick={handleCart}>Add to Cart</button>
                  : <div className="d-flex gap-3 align-items-center w-50">
                    <div className="d-flex gap-3 align-items-center w-50">
                      <button type="button" className="btn btn-light-theme rounded-2 flex-grow-1" onClick={handleDecrement}><i className="bi bi-dash-lg"></i></button>
                      <p className="flex-grow-1 fs-5 text-body-secondary text-center fw-bold m-0">{cartState.cartById[product.slug]}</p>
                      <button type="button" className="btn btn-light-theme rounded-2 flex-grow-1" onClick={handleIncrement}><i className="bi bi-plus-lg"></i></button>
                    </div>
                    <Link to="/cart" className="btn btn-light rounded-2 flex-grow-1">Go to Cart</Link>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    </GuestLayout>
  )
}

export default Product